export default __webpack_public_path__ + "static/media/gift.792429e6.jfif";